import { useTranslation } from 'react-i18next';
import { Archive, ArchiveRestore } from 'lucide-react';

import type { MutationResponse } from '@/types';

import { useArchiveActionMutation } from '@/mutations';

import { DisplayToast, notifyMutationError } from '@/helpers';

type UseArchiveActionsProps = {
  onSuccess: () => void;
};

export const useArchiveActions = (props: UseArchiveActionsProps) => {
  const { onSuccess: propOnSuccess } = props;
  const { t } = useTranslation();

  const { mutate, isPending } = useArchiveActionMutation();

  const onSuccess = (response?: MutationResponse) => {
    if (response?.flash_message) {
      DisplayToast.success(response.flash_message);
    }
    propOnSuccess();
  };

  const toggleArchive = (recordUrl: string, isArchived: boolean) =>
    mutate(`${recordUrl}/${isArchived ? 'restore' : 'archive'}`, {
      onSuccess,
      onError: notifyMutationError,
    });

  const getArchiveMenuItem = (recordUrl: string, isArchived: boolean) => ({
    label: isArchived ? t('Restore') : t('Archive'),
    Icon: isArchived ? ArchiveRestore : Archive,
    onSelect: () => toggleArchive(recordUrl, isArchived),
  });

  const getArchiveTableAction = (recordUrl: string, isArchived: boolean) => ({
    isArchived,
    isPending,
    onClick: () => toggleArchive(recordUrl, isArchived),
  });

  return {
    getArchiveMenuItem,
    getArchiveTableAction,
    isArchiveActionPending: isPending,
  };
};
